class RocketSolutionMedia extends HTMLElement {
  constructor() {
    super();
    this.titleItems = this.querySelectorAll('.rocket-solution-media__item-title');
    this.btnOpenPopup = this.querySelectorAll('.btn-open-popup');
    this.btnClosePopup = this.querySelectorAll('.btn-close-popup');
  }

  connectedCallback() {
    this.toggleContent();
    this.handleStickyOnScroll();
    this.videoPopup();
  }

  videoPopup() {
    this.btnOpenPopup.forEach((btnOpenPopup) => {
      btnOpenPopup.addEventListener('click', function () {
        const selfpopUp = btnOpenPopup.closest('.rocket-solution-media__item');
        selfpopUp.querySelector('.popup-collapsible').classList.remove('hidden');
        document.querySelector('body').classList.add('overflow-hidden');
      });
    });
    this.btnClosePopup.forEach((btnClosePopup) => {
      btnClosePopup.addEventListener('click', function () {
        const selfpopUp = btnClosePopup.closest('.rocket-solution-media__item');
        selfpopUp.querySelector('.popup-collapsible').classList.add('hidden');
        document.querySelector('body').classList.remove('overflow-hidden');
      });
    });
  }

  toggleContent() {
    const showLessContent = this.querySelectorAll('.rocket-solution-media__item-showless');
    if (this.titleItems.length > 0) {
      this.titleItems.forEach((titleItem, index) => {
        if (titleItem) {
          titleItem.addEventListener('click', (event) => {
            this.titleItems.forEach((item) => {
              if (item !== titleItem) {
                item.parentNode.classList.remove('active');
                item.style.marginBottom = '0px'
              }
            });

            if (window.innerWidth > 767) {
              Array.from(this.querySelectorAll('.rocket-solution-media__items-container__right .rocket-solution-media__item-content')).forEach(item => {
                if (!item.classList.contains(`loop-index-${index}`)) {
                  item.classList.remove('active')
                }
              })

              if (this.querySelector(`.rocket-solution-media__items-container__left .rocket-solution-media__item-content.loop-index-${index}`)) {

                this.querySelector(`.rocket-solution-media__items-container__left .rocket-solution-media__item-content.loop-index-${index}`).classList.toggle('active')

                setTimeout(() => {
                  const dataCountItem = titleItem.closest('.rocket-solution-media__item').getAttribute('data-item-count') || 0
                  const heightContent = this.querySelector(`.rocket-solution-media__items-container__left .rocket-solution-media__item-content.loop-index-${index}`).offsetHeight
                  const caculcatorHieght = heightContent + 176 - (dataCountItem * 50)

                  // titleItem.style.setProperty('--margin-bottom-content', `${heightContent}px`)
                  titleItem.closest('.rocket-solution-media__item').style.setProperty('--margin-bottom-content', `${caculcatorHieght}px`)
                  // Jacob added
                  document.querySelector('.rocket-solution-media__items-container').scrollIntoView({ behavior: "smooth" });
                }, 100)
              }

              if(this.querySelector('.rocket-solution-media__description.rocket-solution-media__description-bottom.bottom-bottom')) {
                this.querySelector('.rocket-solution-media__description.rocket-solution-media__description-bottom.bottom-bottom').classList.add('hidden')
              }
            }


            titleItem.parentNode.classList.toggle('active')
          });

          if(window.innerWidth > 767) {
            titleItem.addEventListener('mouseover', (event) => {
              // this.titleItems.forEach((item) => {
              //   if (item !== titleItem) {
              //     item.parentNode.classList.remove('active');
              //   }
              // });

              if(window.innerWidth > 767) {

                let check = false
                Array.from(this.querySelectorAll('.rocket-solution-media__items-container__left .rocket-solution-media__item')).forEach(item => {
                  if(item.classList.contains('active')) {
                    check = true
                  }
                })

                Array.from(this.querySelectorAll('.rocket-solution-media__items-container__right .rocket-solution-media__item-content--preview')).forEach(item => {
                  if(!item.classList.contains(`loop-index-${index}`)) {
                    item.classList.remove('content-clamp-height')
                  }
                })

                if(this.querySelector(`.rocket-solution-media__items-container__left .rocket-solution-media__item-content--preview.loop-index-${index}`)) {
                  this.querySelector(`.rocket-solution-media__items-container__left .rocket-solution-media__item-content--preview.loop-index-${index}`).classList.add('content-clamp-height')
                }

                if(this.querySelector('.rocket-solution-media__description-bottom.bottom-bottom') && !titleItem.parentNode.classList.contains('active') && !check) {
                  this.querySelector('.rocket-solution-media__description-bottom.bottom-bottom').classList.remove('hidden')
                }
              }
            });
          }

          if(window.innerWidth > 767) {
            titleItem.addEventListener('mouseout', (event) => {
              // this.titleItems.forEach((item) => {
              //   if (item !== titleItem) {
              //     item.parentNode.classList.remove('active');
              //   }
              // });

              if(window.innerWidth > 767) {
                Array.from(this.querySelectorAll('.rocket-solution-media__items-container__right .rocket-solution-media__item-content--preview')).forEach(item => {
                  if(!item.classList.contains(`loop-index-${index}`)) {
                    item.classList.remove('content-clamp-height')
                  }
                })

                if(this.querySelector(`.rocket-solution-media__items-container__left .rocket-solution-media__item-content--preview.loop-index-${index}`)) {
                  this.querySelector(`.rocket-solution-media__items-container__left .rocket-solution-media__item-content--preview.loop-index-${index}`).classList.remove('content-clamp-height')
                }

                if(this.querySelector('.rocket-solution-media__description-bottom.bottom-bottom')) {
                  this.querySelector('.rocket-solution-media__description-bottom.bottom-bottom').classList.add('hidden')
                }

                // titleItem.closest('.rocket-solution-media__container').scrollIntoView({ behavior: "smooth" })
              }
            });
          }
        }
      });
    }
    if (showLessContent.length > 0) {
      showLessContent.forEach((showLess, index) => {
        if (showLess) {
          showLess.addEventListener('click', (event) => {

            showLess.closest('.rocket-solution-media__item').classList.remove('active');
            // Jacob added
            showLess.closest('.rocket-solution-media__item').querySelector('.rocket-solution-media__item-title').style.marginBottom = '0px'
            this.handleStickyOnScroll();

            showLess.closest('.rocket-solution-media__container').scrollIntoView({ behavior: "smooth" })
            // const positionShowLess = showLess.closest('.rocket-solution-media__item');
            // const showLessItemRect = positionShowLess.getBoundingClientRect();
            // window.scrollTo({
            //   top: showLessItemRect.top,
            //   behavior: 'smooth'
            // });
          });
        }
      });
    }
  }

  handleStickyOnScroll() {
    window.addEventListener('scroll', this.stickyTitleMb.bind(this));
    this.stickyTitleMb();
  }

  stickyTitleMb() {
    const activeItems = this.querySelectorAll('.rocket-solution-media__item');
    activeItems.forEach((elmActive, indexItem) => {
      const titleItemRect = elmActive.getBoundingClientRect();
      const itemHeight = elmActive.querySelector('.rocket-solution-media__item-title').offsetHeight;
      const headerHeight = document.querySelector('.rocket-header').offsetHeight;
      const mobileActiveItem = headerHeight + 74;
      const mobileNoActiveItem = headerHeight + 34;
      const mobileUnActiveItem = headerHeight + 114;
      if (elmActive.classList.contains('active')) {
        const disableSticky = itemHeight + headerHeight + 200;
        const itemTop = titleItemRect.top;
        const itemBottom = titleItemRect.bottom;
        if (itemBottom <= disableSticky) {
          elmActive.classList.add('sticky-element');
        } else {
          elmActive.classList.remove('sticky-element');
        }
      }
      if (titleItemRect.top < mobileActiveItem && titleItemRect.top > mobileNoActiveItem) {
        elmActive.classList.add('mobile-active');
      } else {
        elmActive.classList.remove('mobile-active');
      }
      if (indexItem === 0 && titleItemRect.top > mobileActiveItem) {
        elmActive.classList.add('mobile-active');
      }

      // Jacob added
      if (window.innerWidth > 767) {
        if (titleItemRect.top < 60 && titleItemRect.top > 0) {
          elmActive.classList.add('bold-active');
        } else {
          elmActive.classList.remove('bold-active');
        }
      }
    });
  }
}

customElements.define('rocket-solution-media', RocketSolutionMedia);